import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ConsultarUmaFuncionalidadeRequest } from './types';

// ACTIONS
import {
	consultarUmaFuncionalidadeSuccess,
	consultarUmaFuncionalidadeFailure,
} from './actions';

function* consultarUmaFuncionalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarUmaFuncionalidadeRequest } = request;

	const body = { ...payload };

	delete body.id;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`funcionalidades/${payload.id}`,
		body,
	);

	if (response.status === 200) {
		yield put(consultarUmaFuncionalidadeSuccess(response));
	} else {
		yield put(consultarUmaFuncionalidadeFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTAR_UMA_FUNCIONALIDADE, consultarUmaFuncionalidade),
]);
